"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4575],{

/***/ 57591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CampaignDetail; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/airdrop/components/Container.tsx
var Container = __webpack_require__(54167);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@usedapp/core/dist/esm/src/hooks/useEthers.js
var useEthers = __webpack_require__(57495);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Loader/Loader.js + 3 modules
var Loader = __webpack_require__(76080);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Modal/Modal.js + 4 modules
var Modal = __webpack_require__(94491);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./node_modules/@usedapp/core/dist/esm/src/hooks/useContractFunction.js + 4 modules
var useContractFunction = __webpack_require__(10391);
// EXTERNAL MODULE: ./node_modules/@ethersproject/abi/lib.esm/interface.js
var lib_esm_interface = __webpack_require__(8198);
// EXTERNAL MODULE: ./node_modules/@ethersproject/contracts/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(64146);
// EXTERNAL MODULE: ./src/chain-info/contracts/NFTAirdropDistributor.json
var NFTAirdropDistributor = __webpack_require__(91704);
;// CONCATENATED MODULE: ./src/airdrop/hooks/useStopNFTAirdrop.ts




var useStopNFTAirdrop = function(NFTAddress) {
    var abi = NFTAirdropDistributor/* abi */.Mt;
    var nftAirdropFactoryInterface = new lib_esm_interface/* Interface */.vU(abi);
    var nftAirdropFactoryContract = new lib_esm.Contract(NFTAddress, nftAirdropFactoryInterface);
    var ref = (0,useContractFunction/* useContractFunction */.j)(nftAirdropFactoryContract, "stopCampaign", {
        transactionName: "Stop Campaign"
    }), stopSend = ref.send, stopNFTAirdropState = ref.state;
    var stopNFTAirdrop = function() {
        return stopSend();
    };
    return {
        stopNFTAirdrop: stopNFTAirdrop,
        stopNFTAirdropState: stopNFTAirdropState
    };
};

// EXTERNAL MODULE: ./src/chain-info/contracts/AirdropDistributor.json
var AirdropDistributor = __webpack_require__(28801);
;// CONCATENATED MODULE: ./src/airdrop/hooks/useStopTokenAirdrop.ts




var useStopTokenAirdrop = function(tokenAddress) {
    var abi = AirdropDistributor/* abi */.Mt;
    var airdropFactoryInterface = new lib_esm_interface/* Interface */.vU(abi);
    var airdropFactoryContract = new lib_esm.Contract(tokenAddress, airdropFactoryInterface);
    var ref = (0,useContractFunction/* useContractFunction */.j)(airdropFactoryContract, "stopCampaign", {
        transactionName: "Stop Campaign"
    }), stopSend = ref.send, stopTokenAirdropState = ref.state;
    var stopTokenAirdrop = function() {
        return stopSend();
    };
    return {
        stopTokenAirdrop: stopTokenAirdrop,
        stopTokenAirdropState: stopTokenAirdropState
    };
};

;// CONCATENATED MODULE: ./src/airdrop/hooks/useStopCampaign.ts


var useStopCampaign = function(campaignAddress, campaignType) {
    // Stop Campaign
    var ref = useStopTokenAirdrop(campaignAddress), stopTokenAirdrop = ref.stopTokenAirdrop, stopTokenAirdropState = ref.stopTokenAirdropState;
    var ref1 = useStopNFTAirdrop(campaignAddress), stopNFTAirdrop = ref1.stopNFTAirdrop, stopNFTAirdropState = ref1.stopNFTAirdropState;
    return campaignType === "TOKEN" ? [
        stopTokenAirdrop,
        stopTokenAirdropState
    ] : [
        stopNFTAirdrop,
        stopNFTAirdropState
    ];
};

// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
;// CONCATENATED MODULE: ./src/airdrop/components/StopCampaignModal.js









var StopCampaignModal = function(param) {
    var campaign = param.campaign, opened = param.opened, setOpened = param.setOpened, campaignAddrArray = param.campaignAddrArray, campaignType = param.campaignType, expectedChain = param.expectedChain, showStopPrompt = param.showStopPrompt, setShowStopPrompt = param.setShowStopPrompt;
    var closeModal = function() {
        setSuccessStop(false);
        setErrorStop(false);
        setOpened(false);
        setVisible(true);
    };
    var ref = (0,useEthers/* useEthers */.K)(), chainId = ref.chainId, switchNetwork = ref.switchNetwork;
    var ref1 = (0,react.useState)(true), frozenModal = ref1[0], setFrozenModal = ref1[1];
    var ref2 = (0,react.useState)(""), loadingPrompt = ref2[0], setLoadingPrompt = ref2[1];
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var switchNet = function() {
        switchNetwork(expectedChain === null || expectedChain === void 0 ? void 0 : expectedChain.chainId);
    };
    var customLoader = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                color: "#ADB5FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-5",
                children: loadingPrompt
            })
        ]
    });
    var campaignAddr = campaignAddrArray[0];
    var ref4 = (0,_sliced_to_array/* default */.Z)(useStopCampaign(campaignAddr, campaignType), 2), stopCampaign = ref4[0], stopCampaignStatus = ref4[1];
    // eslint-disable-next-line
    var ref5 = (0,react.useState)(true), visible = ref5[0], setVisible = ref5[1];
    var ref6 = (0,react.useState)(false), successStop = ref6[0], setSuccessStop = ref6[1];
    var ref7 = (0,react.useState)(false), errorStop = ref7[0], setErrorStop = ref7[1];
    var formik = (0,formik_esm/* useFormik */.TA)({
        initialValues: {
            campaignAddr: campaignAddr,
            campaignType: campaignType,
            expectedChain: expectedChain
        },
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(values, param) {
                var setSubmitting, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setSubmitting = param.setSubmitting;
                            if (!(campaign.isActive === true)) return [
                                3,
                                5
                            ];
                            setSubmitting(true);
                            setSuccessStop(false);
                            setLoading(true);
                            setErrorStop(false);
                            setVisible(false);
                            setShowStopPrompt(false);
                            setFrozenModal(false);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                stopCampaign(values)
                            ];
                        case 2:
                            _state.sent();
                            setFrozenModal(true);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            err = _state.sent();
                            console.log(err);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            setSubmitting(false);
                            return [
                                3,
                                6
                            ];
                        case 5:
                            setErrorStop(true);
                            setVisible(false);
                            setShowStopPrompt(false);
                            _state.label = 6;
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(values, _) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    (0,react.useEffect)(function() {
        if (stopCampaignStatus.status === "Exception") {
            setErrorStop(true);
            setLoading(false);
        } else {
            if (stopCampaignStatus.status === "Success") {
                setSuccessStop(true);
                setLoading(false);
            } else if (stopCampaignStatus.status === "Mining") {
                setLoadingPrompt("Stopping...");
            } else if (stopCampaignStatus.status === "PendingSignature") {
                setLoadingPrompt("Comfirming with Your Wallet...");
            }
        }
    }, [
        stopCampaignStatus,
        setLoadingPrompt,
        setSuccessStop
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
            opened: opened,
            closeOnClickOutside: frozenModal,
            withCloseButton: false,
            padding: "40px 60px",
            centered: true,
            onClose: closeModal,
            styles: {
                modal: {
                    textAlign: "center",
                    borderColor: "#94949C",
                    borderWidth: "1px"
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: loading ? "flex flex-col" : "hidden flex-col",
                    children: customLoader
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: successStop ? "flex flex-col" : "hidden flex-col",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-center",
                            children: "Campaign Stopped Successfully!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            className: "btn-pri mx-auto mt-10 mb-3 w-48 px-12 hover:bg-bgv2",
                            onClick: closeModal,
                            children: "Close"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: errorStop ? "flex flex-col" : "hidden flex-col",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-center",
                            children: "Campaign Stopped Unsuccessfully!"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            className: " btn-pri mx-auto mt-10 mb-3 w-48 px-12 hover:bg-bgv2",
                            onClick: closeModal,
                            children: "Close"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: showStopPrompt ? "flex flex-col " : " hidden flex-col ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: " text-md font-bold",
                            children: "Are you sure you want to stop this campaign"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-xs font-normal text-gray1",
                            children: [
                                "Once you stop this campaign, you won't be able to ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "re-start it and new users won't be able to claim it."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-row justify-around",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    class: "btn-pri w-content mt-5 bg-gray px-12 hover:bg-bgv2",
                                    onClick: closeModal,
                                    children: "No"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                    autoComplete: "off",
                                    onSubmit: formik.handleSubmit,
                                    children: chainId !== (expectedChain === null || expectedChain === void 0 ? void 0 : expectedChain.chainId) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                        class: "btn-pri mt-5 px-12",
                                        onClick: switchNet,
                                        children: [
                                            "Switch to ",
                                            expectedChain === null || expectedChain === void 0 ? void 0 : expectedChain.chainName,
                                            " Network"
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        class: "btn-pri w-content mt-5 px-12",
                                        type: "submit",
                                        children: "Yes"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_StopCampaignModal = (StopCampaignModal);

// EXTERNAL MODULE: ./node_modules/@usedapp/core/dist/esm/src/providers/notifications/context.js
var context = __webpack_require__(3453);
;// CONCATENATED MODULE: ./node_modules/@usedapp/core/dist/esm/src/hooks/useInterval.js

// https://usehooks-typescript.com/react-hook/use-interval
/**
 * @internal Intended for internal use - use it on your own risk
 */
function useInterval(callback, delay) {
    const savedCallback = (0,react.useRef)(callback);
    (0,react.useEffect)(() => {
        savedCallback.current = callback;
    }, [callback]);
    (0,react.useEffect)(() => {
        if (delay === null) {
            return;
        }
        const id = setInterval(() => savedCallback.current(), delay);
        return () => clearInterval(id);
    }, [delay]);
}
//# sourceMappingURL=useInterval.js.map
// EXTERNAL MODULE: ./node_modules/@usedapp/core/dist/esm/src/hooks/useConfig.js
var useConfig = __webpack_require__(75405);
;// CONCATENATED MODULE: ./node_modules/@usedapp/core/dist/esm/src/hooks/useNotifications.js





function getExpiredNotifications(notifications, expirationPeriod) {
    if (expirationPeriod === 0) {
        return [];
    }
    const timeFromCreation = (creationTime) => Date.now() - creationTime;
    return notifications.filter((notification) => timeFromCreation(notification.submittedAt) >= expirationPeriod);
}
/**
 * ``useNotifications`` is a hook that is used to access notifications.
 * Notifications include information about: new transactions, transaction success or failure, as well as connection to a new wallet.
 *
 * To use this hook call:
 *
 * ```tsx
 *   const { notifications } = useNotifications()
 * ```
 *
 * `notifications` is an array of `NotificationPayload`.
 *
 * Each notification is removed from `notifications` after time declared in
 * `config.notifications.expirationPeriod`
 *
 * Each can be one of the following:
 *
 * ```tsx
 *   {
 *     type: 'walletConnected';
 *     address: string
 *   }
 * ```
 *
 * ```tsx
 *   {
 *     type: 'transactionStarted';
 *     submittedAt: number
 *     transaction: TransactionResponse;
 *     transactionName?: string
 *   }
 * ```
 *
 * ```tsx
 *   {
 *     type: 'transactionSucceed'
 *     transaction: TransactionResponse
 *     originalTransaction?: TransactionResponse
 *     receipt: TransactionReceipt
 *     transactionName?: string
 *   }
 * ```
 *
 * ```tsx
 *   {
 *     type: 'transactionFailed'
 *     transaction: TransactionResponse
 *     originalTransaction?: TransactionResponse
 *     receipt: TransactionReceipt
 *     transactionName?: string
 *   }
 * ```
 *
 * @public
 * @see [Transaction Response](https://docs.ethers.io/v5/api/providers/types/#providers-TransactionResponse)
 * @see [Transaction Receipt](https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt)
 */
function useNotifications() {
    const { chainId, account } = (0,useEthers/* useEthers */.K)();
    const { addNotification, notifications, removeNotification } = (0,context/* useNotificationsContext */.l)();
    const { notifications: { checkInterval, expirationPeriod }, } = (0,useConfig/* useConfig */.Z)();
    const chainNotifications = (0,react.useMemo)(() => {
        var _a;
        if (chainId === undefined || !account) {
            return [];
        }
        return (_a = notifications[chainId]) !== null && _a !== void 0 ? _a : [];
    }, [notifications, chainId, account]);
    useInterval(() => {
        if (!chainId) {
            return;
        }
        const expiredNotification = getExpiredNotifications(chainNotifications, expirationPeriod);
        for (const notification of expiredNotification) {
            removeNotification({ notificationId: notification.id, chainId });
        }
    }, checkInterval);
    return {
        notifications: chainNotifications,
        addNotification,
        removeNotification,
    };
}
//# sourceMappingURL=useNotifications.js.map
// EXTERNAL MODULE: ./src/chain-info/KaratDaoSupportedChain.ts
var KaratDaoSupportedChain = __webpack_require__(93171);
// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var units_lib_esm = __webpack_require__(61744);
// EXTERNAL MODULE: ./src/airdrop/components/Web3ModalButton.tsx + 1 modules
var Web3ModalButton = __webpack_require__(48366);
// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/addresses.js
var addresses = __webpack_require__(9279);
// EXTERNAL MODULE: ./src/hooks/useAccount.tsx
var useAccount = __webpack_require__(98786);
// EXTERNAL MODULE: ./node_modules/mixpanel-browser/dist/mixpanel.cjs.js
var mixpanel_cjs = __webpack_require__(8891);
var mixpanel_cjs_default = /*#__PURE__*/__webpack_require__.n(mixpanel_cjs);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
;// CONCATENATED MODULE: ./src/airdrop/hooks/useClaimAirdrop.ts








var useClaimAirdrop = function(campaignType, distributorAddress) {
    var address = (0,useAccount/* default */.Z)().address;
    var chain = (0,dist/* useNetwork */.LN)().chain;
    var airdropDistributorAbi = AirdropDistributor/* abi */.Mt;
    var nftAirdropDistributorAbi = NFTAirdropDistributor/* abi */.Mt;
    var abi = campaignType === "TOKEN" ? airdropDistributorAbi : nftAirdropDistributorAbi;
    var contractInterface = new lib_esm_interface/* Interface */.vU(abi);
    var contract = new lib_esm.Contract(distributorAddress !== null && distributorAddress !== void 0 ? distributorAddress : addresses/* AddressZero */.d, contractInterface);
    var ref = (0,useContractFunction/* useContractFunction */.j)(contract, "claim", {
        transactionName: "Claim Airdrop"
    }), claimAirdropState = ref.state, claimAirdropSend = ref.send;
    var claimAirdrop = function(amount, merkleProof) {
        mixpanel_cjs_default().track("claim_airdrop", {
            amount: amount,
            merkleProof: merkleProof,
            distributorAddress: distributorAddress,
            campaignType: campaignType,
            address: address,
            chain: chain
        });
        if (!amount) {
            throw new Error("Amount is required");
        }
        return claimAirdropSend(address, amount, merkleProof); //FIXME Test super large amount for token
    };
    return {
        claimAirdrop: claimAirdrop,
        claimAirdropState: claimAirdropState
    };
};

// EXTERNAL MODULE: ./src/airdrop/utils/helper.ts
var helper = __webpack_require__(89351);
// EXTERNAL MODULE: ./src/airdrop/hooks/useCampaignInfo.ts
var useCampaignInfo = __webpack_require__(87655);
// EXTERNAL MODULE: ./src/airdrop/hooks/useFetchData.ts
var useFetchData = __webpack_require__(82741);
// EXTERNAL MODULE: ./node_modules/@usedapp/core/dist/esm/src/hooks/useCall.js + 1 modules
var useCall = __webpack_require__(24627);
;// CONCATENATED MODULE: ./src/airdrop/hooks/useClaimed.ts





var useClaimed = function(airdropAddr, claimAccount, expectedChainId) {
    var ref = (0,react.useState)(), error = ref[0], setError = ref[1];
    var ref1 = (0,react.useState)(), claimed = ref1[0], setClaimed = ref1[1];
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var abi = AirdropDistributor/* abi */.Mt;
    var airdropDistributorInterface = new lib_esm_interface/* Interface */.vU(abi);
    var airdropDistributorContract = new lib_esm.Contract(airdropAddr !== null && airdropAddr !== void 0 ? airdropAddr : addresses/* AddressZero */.d, airdropDistributorInterface);
    var ref3;
    var ref4 = (ref3 = (0,useCall/* useCall */.W)(// @ts-ignore
    claimAccount && {
        contract: airdropDistributorContract,
        method: "claimed",
        args: [
            claimAccount
        ]
    }, {
        chainId: expectedChainId
    })) !== null && ref3 !== void 0 ? ref3 : {}, value = ref4.value, callError = ref4.error;
    if (callError) {
        console.error(callError.message);
    }
    (0,react.useEffect)(function() {
        setLoading(true);
        if (value) {
            setClaimed(value === null || value === void 0 ? void 0 : value[0]);
            setLoading(false);
        }
        if (callError) {
            setError(callError.message);
            setLoading(false);
        }
    }, [
        callError,
        value
    ]);
    return {
        claimed: claimed,
        error: error,
        loading: loading
    };
};
/* harmony default export */ var hooks_useClaimed = (useClaimed);

// EXTERNAL MODULE: ./node_modules/@ethersproject/address/lib.esm/index.js + 1 modules
var address_lib_esm = __webpack_require__(19485);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(87165);
;// CONCATENATED MODULE: ./src/airdrop/components/ClaimModal.js





var ClaimModal = function(param) {
    var opened = param.opened, setOpened = param.setOpened, claimStatus = param.claimStatus;
    var finishClaim = function() {
        setOpened(false);
    };
    return claimStatus === "finished" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
        opened: opened,
        centered: true,
        onClose: finishClaim,
        withCloseButton: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineCancel */.xg7, {
                className: "hover: absolute top-4 right-6 h-6 w-6 text-primary",
                onClick: finishClaim
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center justify-center",
                "data-testid": "claim-success-modal",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/airdrop_assets/confirmpage_check.png",
                        alt: "checkmark",
                        className: "mt-10 mb-7 w-16"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-3 text-center text-base font-bold text-primary",
                        children: "Claim Successful"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-9 text-sm text-gray1",
                        children: "You can view your airdrop in your wallet"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "btn-pri mb-12 px-16",
                        onClick: finishClaim,
                        children: "Close"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
        opened: opened,
        centered: true,
        withCloseButton: false,
        closeOnClickOutside: false,
        closeOnEscape: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col items-center justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-4 mt-6",
                        children: claimStatus === "claiming" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                            color: "#ADB5FF",
                            size: 50
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiFillCheckCircle */.mny, {
                            color: "#ADB5FF",
                            size: "50px"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center justify-center text-white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-3 text-center text-base font-bold text-primary",
                                children: "Claim Your Airdrop"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-5 text-center text-sm text-gray1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "Please wait while we claim your airdrop"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_ClaimModal = (ClaimModal);

// EXTERNAL MODULE: ./src/services/ga.ts
var ga = __webpack_require__(77131);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Textarea/Textarea.js + 4 modules
var Textarea = __webpack_require__(67288);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/TextInput/TextInput.js
var TextInput = __webpack_require__(80061);
// EXTERNAL MODULE: ./src/airdrop/components/ImageUploader.js
var ImageUploader = __webpack_require__(60105);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 26 modules
var es = __webpack_require__(7258);
// EXTERNAL MODULE: ./src/airdrop/models/pinata.ts
var pinata = __webpack_require__(39849);
// EXTERNAL MODULE: ./src/airdrop/models/project.ts
var project = __webpack_require__(32653);
// EXTERNAL MODULE: ./src/airdrop/utils/formValidation.js
var formValidation = __webpack_require__(15080);
// EXTERNAL MODULE: ./src/airdrop/utils/request.js + 1 modules
var request = __webpack_require__(38487);
;// CONCATENATED MODULE: ./src/airdrop/models/image.ts



var addImage = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(image) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        request/* default.rpc */.Z.rpc("image/add", {
                            base64: image
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function addImage(image) {
        return _ref.apply(this, arguments);
    };
}();
var getImage = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        request/* default.rpc */.Z.rpc("image/get", {
                            id: id
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getImage(id) {
        return _ref.apply(this, arguments);
    };
}();
var uploadImage = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(image) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        request/* default.rpc */.Z.rpc("image/upload_image", {
                            url: image
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function uploadImage(image) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/airdrop/hooks/usePinata.js




// eslint-disable-next-line



var usePinata = function() {
    var ref = (0,react.useState)(""), pinataError = ref[0], setPinataError = ref[1];
    var ref1 = (0,react.useState)("unfinished"), pinataStatus = ref1[0], setPinataStatus = ref1[1];
    var uploadForm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(props) {
            var baseDataPromise, frozenDataPromise, initSubmitForm, generateProjMetaDataForm, generateFrozenDataForm, hashs, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        baseDataPromise = function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(formToSubmit) {
                                var imgData, imgResult, baseData, baseResult;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            imgData = new FormData();
                                            imgData.append("file", formToSubmit.thumbnail);
                                            (0,formValidation/* checkSimpleUndefined */.Tl)(imgData);
                                            return [
                                                4,
                                                (0,pinata/* pinFileToIPFS */.MU)(imgData)
                                            ];
                                        case 1:
                                            imgResult = _state.sent();
                                            baseData = {
                                                description: formToSubmit.description,
                                                image: "ipfs://" + imgResult.data.IpfsHash,
                                                website_url: formToSubmit.website_url
                                            };
                                            if (formToSubmit.twitter_url) {
                                                baseData["twitter_url"] = formToSubmit.twitter_url;
                                            }
                                            if (formToSubmit.discord_url) {
                                                baseData["discord_url"] = formToSubmit.discord_url;
                                            }
                                            if (formToSubmit.opensea_url) {
                                                baseData["opensea_url"] = formToSubmit.opensea_url;
                                            }
                                            (0,formValidation/* checkSimpleUndefined */.Tl)(baseData);
                                            return [
                                                4,
                                                (0,pinata/* pinJSONToIPFS */.N$)(baseData)
                                            ];
                                        case 2:
                                            baseResult = _state.sent();
                                            setPinataStatus("baseDataUploaded");
                                            return [
                                                2,
                                                "ipfs://" + baseResult.data.IpfsHash
                                            ];
                                    }
                                });
                            });
                            return function baseDataPromise(formToSubmit) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        frozenDataPromise = function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(initSubmitForm, generateProjMetaDataForm, generateFrozenDataForm) {
                                var projMetaDataForm, claimResult, frozenData, frozenResult, err;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                3,
                                                ,
                                                4
                                            ]);
                                            projMetaDataForm = generateProjMetaDataForm(initSubmitForm);
                                            (0,formValidation/* checkSimpleUndefined */.Tl)(projMetaDataForm);
                                            return [
                                                4,
                                                (0,project/* getProjectMetaData */.$f)(projMetaDataForm)
                                            ];
                                        case 1:
                                            claimResult = _state.sent();
                                            frozenData = generateFrozenDataForm(initSubmitForm, claimResult);
                                            (0,formValidation/* checkSimpleUndefined */.Tl)(frozenData);
                                            return [
                                                4,
                                                (0,pinata/* pinJSONToIPFS */.N$)(frozenData)
                                            ];
                                        case 2:
                                            frozenResult = _state.sent();
                                            // console.log('frozenResult:', frozenResult);
                                            setPinataStatus("frozenDataUploaded");
                                            return [
                                                2,
                                                [
                                                    "ipfs://" + frozenResult.data.IpfsHash,
                                                    claimResult.merkleRoot
                                                ]
                                            ];
                                        case 3:
                                            err = _state.sent();
                                            console.log("err:", err);
                                            throw err;
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function frozenDataPromise(initSubmitForm, generateProjMetaDataForm, generateFrozenDataForm) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        initSubmitForm = props.initSubmitForm, generateProjMetaDataForm = props.generateProjMetaDataForm, generateFrozenDataForm = props.generateFrozenDataForm;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            new Promise(function(resolve, reject) {
                                Promise.all([
                                    baseDataPromise(initSubmitForm),
                                    frozenDataPromise(initSubmitForm, generateProjMetaDataForm, generateFrozenDataForm), 
                                ]).then(function(result) {
                                    resolve(result);
                                }).catch(function(err) {
                                    reject(err);
                                });
                                setTimeout(function() {
                                    reject(new Error("Upload Pinata Time Out"));
                                }, 300000);
                            })
                        ];
                    case 2:
                        hashs = _state.sent();
                        setPinataStatus("FINISH");
                        return [
                            2,
                            hashs
                        ];
                    case 3:
                        err = _state.sent();
                        setPinataStatus("error");
                        setPinataError(err);
                        throw new Error(err.message);
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadForm(props) {
            return _ref.apply(this, arguments);
        };
    }();
    var uploadEditForm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(props) {
            var baseDataPromise, hashs, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        baseDataPromise = function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(formToSubmit) {
                                var ref, ref1, imgData, imgResult, imgHash, err, baseData, ref2, baseResult;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            console.log("formToSubmit:", formToSubmit);
                                            imgData = new FormData();
                                            imgResult = "";
                                            if (!!formToSubmit.thumbnail.toString().startsWith("ipfs://")) return [
                                                3,
                                                2
                                            ];
                                            imgData.append("file", formToSubmit.thumbnail);
                                            (0,formValidation/* checkSimpleUndefined */.Tl)(imgData);
                                            return [
                                                4,
                                                (0,pinata/* pinFileToIPFS */.MU)(imgData)
                                            ];
                                        case 1:
                                            imgResult = _state.sent();
                                            _state.label = 2;
                                        case 2:
                                            imgHash = imgResult === null || imgResult === void 0 ? void 0 : (ref = imgResult.data) === null || ref === void 0 ? void 0 : ref.IpfsHash;
                                            if (!(imgResult !== undefined)) return [
                                                3,
                                                6
                                            ];
                                            _state.label = 3;
                                        case 3:
                                            _state.trys.push([
                                                3,
                                                5,
                                                ,
                                                6
                                            ]);
                                            return [
                                                4,
                                                uploadImage(pinata_address + imgHash)
                                            ];
                                        case 4:
                                            _state.sent();
                                            console.log("Compressd Image uploaded");
                                            return [
                                                3,
                                                6
                                            ];
                                        case 5:
                                            err = _state.sent();
                                            console.log("err:", err);
                                            return [
                                                3,
                                                6
                                            ];
                                        case 6:
                                            baseData = {
                                                description: formToSubmit.description,
                                                website_url: formToSubmit.website_url
                                            };
                                            // if user upload did not change the image keep the old ipfs hash
                                            if (formToSubmit.thumbnail.toString().startsWith("ipfs://")) {
                                                baseData["image"] = formToSubmit.thumbnail.toString();
                                            } else {
                                                ;
                                                // else use the new ipfs hash
                                                baseData["image"] = "ipfs://" + (imgResult === null || imgResult === void 0 ? void 0 : (ref2 = imgResult.data) === null || ref2 === void 0 ? void 0 : ref2.IpfsHash);
                                            }
                                            if (formToSubmit.twitter_url) {
                                                baseData["twitter_url"] = formToSubmit.twitter_url;
                                            }
                                            if (formToSubmit.discord_url) {
                                                baseData["discord_url"] = formToSubmit.discord_url;
                                            }
                                            if (formToSubmit.opensea_url) {
                                                baseData["opensea_url"] = formToSubmit.opensea_url;
                                            }
                                            (0,formValidation/* checkSimpleUndefined */.Tl)(baseData);
                                            return [
                                                4,
                                                (0,pinata/* pinJSONToIPFS */.N$)(baseData)
                                            ];
                                        case 7:
                                            baseResult = _state.sent();
                                            setPinataStatus("baseDataUploaded");
                                            return [
                                                2,
                                                "ipfs://" + (baseResult === null || baseResult === void 0 ? void 0 : (ref1 = baseResult.data) === null || ref1 === void 0 ? void 0 : ref1.IpfsHash)
                                            ];
                                    }
                                });
                            });
                            return function baseDataPromise(formToSubmit) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        console.log("props:", props);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            new Promise(function(resolve, reject) {
                                Promise.all([
                                    baseDataPromise(props)
                                ]).then(function(result) {
                                    resolve(result);
                                });
                                setTimeout(function() {
                                    reject(new Error("Upload Pinata Time Out"));
                                }, 300000);
                            })
                        ];
                    case 2:
                        hashs = _state.sent();
                        setPinataStatus("FINISH");
                        return [
                            2,
                            hashs
                        ];
                    case 3:
                        err = _state.sent();
                        setPinataError(err);
                        throw new Error(err.message);
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function uploadEditForm(props) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        pinataStatus: pinataStatus,
        pinataError: pinataError,
        uploadForm: uploadForm,
        uploadEditForm: uploadEditForm,
        setPinataStatus: setPinataStatus
    };
};

;// CONCATENATED MODULE: ./src/airdrop/hooks/useUpdateTokenAirdrop.ts




var useUpdateTokenAirdrop = function(tokenAddress) {
    var abi = AirdropDistributor/* abi */.Mt;
    var airdropFactoryInterface = new lib_esm_interface/* Interface */.vU(abi);
    var airdropFactoryContract = new lib_esm.Contract(tokenAddress, airdropFactoryInterface);
    var ref = (0,useContractFunction/* useContractFunction */.j)(airdropFactoryContract, "updateBaseInfoURI", {
        transactionName: "Update Campaign"
    }), updateSend = ref.send, updateTokenAirdropState = ref.state;
    var updateTokenAirdrop = function(ipfs) {
        console.log("HERE:", ipfs);
        return updateSend(ipfs);
    };
    return {
        updateTokenAirdrop: updateTokenAirdrop,
        updateTokenAirdropState: updateTokenAirdropState
    };
};

;// CONCATENATED MODULE: ./src/airdrop/hooks/useUpdateNFTAirdrop.ts




var useUpdateNFTAirdrop = function(NFTAddress) {
    var abi = NFTAirdropDistributor/* abi */.Mt;
    var nftAirdropFactoryInterface = new lib_esm_interface/* Interface */.vU(abi);
    var nftAirdropFactoryContract = new lib_esm.Contract(NFTAddress, nftAirdropFactoryInterface);
    var ref = (0,useContractFunction/* useContractFunction */.j)(nftAirdropFactoryContract, "updateBaseInfoURI", {
        transactionName: "Update Campaign"
    }), updateSend = ref.send, updateNFTAirdropState = ref.state;
    var updateNFTAirdrop = function(ipfs) {
        console.log("HERE:", ipfs);
        return updateSend(ipfs);
    };
    return {
        updateNFTAirdrop: updateNFTAirdrop,
        updateNFTAirdropState: updateNFTAirdropState
    };
};

;// CONCATENATED MODULE: ./src/airdrop/hooks/useUpdateCampaign.ts


var useUpdateCampaign = function(campaignAddress, campaignType) {
    // update
    var ref = useUpdateTokenAirdrop(campaignAddress), updateTokenAirdrop = ref.updateTokenAirdrop, updateTokenAirdropState = ref.updateTokenAirdropState;
    var ref1 = useUpdateNFTAirdrop(campaignAddress), updateNFTAirdrop = ref1.updateNFTAirdrop, updateNFTAirdropState = ref1.updateNFTAirdropState;
    return campaignType === "TOKEN" ? [
        updateTokenAirdrop,
        updateTokenAirdropState
    ] : [
        updateNFTAirdrop,
        updateNFTAirdropState
    ];
};

;// CONCATENATED MODULE: ./src/airdrop/components/LoadingModal.js



var LoadingModal = function(param) {
    var loadingOpen = param.loadingOpen, setLoadingOpen = param.setLoadingOpen, loadingPrompt = param.loadingPrompt, setLoadingPrompt = param.setLoadingPrompt, setOpened = param.setOpened;
    var ref = (0,react.useState)(false), doneEdit = ref[0], setDoneEdit = ref[1];
    var ref1 = (0,react.useState)("Close"), buttonPrompt = ref1[0], setButtonPrompt = ref1[1];
    var ref2 = (0,react.useState)(false), successUpdate = ref2[0], setSuccessUpdate = ref2[1];
    var ref3 = (0,react.useState)(false), interruptedUpdate = ref3[0], setInterruptedUpdate = ref3[1];
    //   const [errorMessage, setErrorMessage] = useState('');
    // useEffect(() => {
    //   if (updateState.status === 'Exception') {
    //     setInterruptedUpdate(true);
    //     setButtonPrompt('Try Again');
    //   } else if (updateState.status === 'Success') {
    //     setSuccessUpdate(true);
    //     setDoneEdit(true);
    //     setButtonPrompt('Close');
    //   }
    //   //eslint-disable-next-line
    // }, [updateState]);
    // depending on prompt, set button prompt
    (0,react.useEffect)(function() {
        if (loadingPrompt === "Success") {
            setSuccessUpdate(true);
            setDoneEdit(true);
            setButtonPrompt("Close");
        }
        if (loadingPrompt === "Error") {
            setInterruptedUpdate(true);
            setDoneEdit(true);
            setButtonPrompt("Try Again");
        }
    }, [
        loadingPrompt,
        setLoadingPrompt
    ]);
    var customLoader = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: doneEdit ? "hidden flex-col items-center" : "flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                color: "#ADB5FF"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-5",
                children: loadingPrompt
            })
        ]
    });
    // if success, show close button and return out of modal and close modal
    // if interrupted, show try again button and return out of modal but not close modal
    var closeModal = function() {
        if (buttonPrompt === "Close") {
            setLoadingPrompt("");
            setDoneEdit(false);
            setSuccessUpdate(false);
            setInterruptedUpdate(false);
            setLoadingOpen(false);
            setOpened(false);
        } else if (buttonPrompt === "Try Again") {
            setLoadingPrompt("");
            setDoneEdit(false);
            setSuccessUpdate(false);
            setInterruptedUpdate(false);
            setLoadingOpen(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
            opened: loadingOpen,
            closeOnClickOutside: false,
            onClose: closeModal,
            withCloseButton: false,
            centered: true,
            padding: "60px 30px",
            styles: {
                modal: {
                    textAlign: "center",
                    borderRadius: "10px",
                    padding: "20px",
                    width: "300px"
                }
            },
            children: [
                customLoader,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: successUpdate && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center justify-center ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "mb-5 h-20 w-20",
                                src: "/airdrop_assets/confirmpage_check.png",
                                alt: "Confirm"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Changes Successfully Saved "
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: interruptedUpdate && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center justify-center ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "mb-5 h-20 w-20",
                                src: "/airdrop_assets/warning.png",
                                alt: "Warning"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "We weren't able to save your changes"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    className: doneEdit ? "btn-pri mx-auto mt-10 block w-44 px-12 hover:bg-bgv2" : "btn-pri mx-auto mt-10 hidden px-12 hover:bg-bgv2",
                    onClick: closeModal,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: buttonPrompt
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_LoadingModal = (LoadingModal);

;// CONCATENATED MODULE: ./src/airdrop/components/EditCampaignModal.js






// import urlToHttp from '../utils/urlToHttp';








var EditCampaignModal = function(param) {
    var opened = param.opened, setOpened = param.setOpened, baseInfo = param.baseInfo, campaignAddrArray = param.campaignAddrArray, expectedChain = param.expectedChain, campaignType = param.campaignType;
    // const [closeListener, setCloseListener] = useState(false);
    var ref = (0,react.useState)(""), loadingPrompt = ref[0], setLoadingPrompt = ref[1];
    // const [visible, setVisible] = useState(false);
    var ref1 = (0,react.useState)(false), loadingModalOpened = ref1[0], setLoadingModalOpened = ref1[1];
    var modal = (0,react.useRef)(null);
    var ref2 = (0,useEthers/* useEthers */.K)(), chainId = ref2.chainId, switchNetwork = ref2.switchNetwork;
    // eslint-disable-next-line
    var uploadEditForm = usePinata().uploadEditForm;
    var FILE_SIZE = 35 * 1024 * 1024;
    var SUPPORTED_FORMATS = [
        "image/jpg",
        "image/jpeg",
        "image/gif",
        "image/png", 
    ];
    var ref3 = (0,react.useState)(true), frozenModal = ref3[0], setFrozenModal = ref3[1];
    // const [successUpdate, setSuccessUpdate] = useState(false);
    // const [interruptedUpdate, setInterruptedUpdate] = useState(false);
    var formSchema = es/* object */.Ry({
        thumbnail: es/* mixed */.nK().required("Image is required").test("fileSize", "File too large", function(value) {
            if (typeof value === "string") {
                return true;
            } else {
                return value && value.size <= FILE_SIZE;
            }
        }).test("fileFormat", "Unsupported Format", function(value) {
            if (typeof value === "string") {
                return true;
            } else {
                return value && SUPPORTED_FORMATS.includes(value.type);
            }
        }),
        description: es/* string */.Z_().required(),
        twitter_url: es/* string */.Z_().url("Please enter a valid url"),
        discord_url: es/* string */.Z_().url("Please enter a valid url"),
        website_url: es/* string */.Z_().url("Please enter a valid url").required("Website url is required"),
        opensea_url: es/* string */.Z_().url("Please enter a valid url")
    });
    var info = {
        description: "",
        twitter_url: "",
        discord_url: "",
        website_url: "",
        opensea_url: "",
        thumbnail: ""
    };
    // eslint-disable-next-line
    var campaignAddr = campaignAddrArray[0];
    // eslint-disable-next-line
    var ref4 = (0,_sliced_to_array/* default */.Z)(useUpdateCampaign(campaignAddr, campaignType), 2), updateBaseInfoURI = ref4[0], updateState = ref4[1];
    (0,react.useEffect)(function() {
        if (updateState.status === "Exception") {
            setLoadingPrompt("Error");
        }
        if (updateState.status === "Success") {
            setLoadingPrompt("Success");
        }
        if (updateState.status === "Mining") {
            setLoadingPrompt("Updating...");
        }
    //eslint-disable-next-line
    }, [
        updateState.status
    ]);
    var formik = (0,formik_esm/* useFormik */.TA)({
        // enableReinitialize: true,
        initialValues: baseInfo ? baseInfo : info,
        validationSchema: formSchema,
        onSubmit: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(values, actions) {
                var EditCampaignForm, ref, baseHash, err;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(Object.keys(formik.errors).length !== 0)) return [
                                3,
                                1
                            ];
                            actions.setSubmitting(false);
                            return [
                                3,
                                7
                            ];
                        case 1:
                            // setSuccessUpdate(false);
                            // setInterruptedUpdate(false);
                            // setVisible(true);
                            setFrozenModal(false);
                            EditCampaignForm = {
                                description: formik.values.description,
                                twitter_url: formik.values.twitter_url,
                                discord_url: formik.values.discord_url,
                                website_url: formik.values.website_url,
                                opensea_url: formik.values.opensea_url,
                                thumbnail: formik.values.thumbnail
                            };
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                5,
                                ,
                                6
                            ]);
                            setLoadingPrompt("Uploading Base Info...");
                            return [
                                4,
                                uploadEditForm(EditCampaignForm)
                            ];
                        case 3:
                            ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                                _state.sent(),
                                1
                            ]), baseHash = ref[0];
                            setLoadingPrompt("Waiting for confirmation...");
                            return [
                                4,
                                updateBaseInfoURI(baseHash)
                            ];
                        case 4:
                            _state.sent();
                            setLoadingPrompt("Done Confirming");
                            return [
                                3,
                                6
                            ];
                        case 5:
                            err = _state.sent();
                            console.log("Error: here is the error");
                            console.log(err);
                            return [
                                3,
                                6
                            ];
                        case 6:
                            setFrozenModal(true);
                            _state.label = 7;
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(values, actions) {
                return _ref.apply(this, arguments);
            };
        }()
    });
    (0,react.useEffect)(function() {
        formik.setFieldValue("description", baseInfo.description);
        formik.setFieldValue("twitter_url", baseInfo.twitter_url);
        var ref;
        formik.setFieldValue("thumbnail", (ref = baseInfo === null || baseInfo === void 0 ? void 0 : baseInfo.image_hash) !== null && ref !== void 0 ? ref : baseInfo === null || baseInfo === void 0 ? void 0 : baseInfo.image);
        formik.setFieldValue("website_url", baseInfo.website_url);
        formik.setFieldValue("discord_url", baseInfo.discord_url);
        formik.setFieldValue("opensea_url", baseInfo.opensea_url);
    }, [
        baseInfo
    ]); // eslint-disable-line
    var switchNet = function() {
        switchNetwork(expectedChain === null || expectedChain === void 0 ? void 0 : expectedChain.chainId);
    };
    var initOverLay = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (Object.keys(formik.errors).length !== 0) {
                    console.log("errors", formik.errors);
                } else {
                    setLoadingModalOpened(true);
                // setVisible(true);
                }
                return [
                    2
                ];
            });
        });
        return function initOverLay() {
            return _ref.apply(this, arguments);
        };
    }();
    var closeModal = function() {
        // setSuccessUpdate(false);
        // setInterruptedUpdate(false);
        setOpened(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
        ref: modal,
        opened: opened,
        closeOnClickOutside: frozenModal,
        id: "edit-campaign-modal",
        title: "Edit Campaign Details",
        onClose: closeModal,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                autoComplete: "off",
                onSubmit: formik.handleSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        className: "label-form",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Description"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "ml-1 text-warning",
                                children: "*"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea/* Textarea */.g, {
                        classNames: {
                            label: "label-form",
                            input: formik.errors.description && formik.touched.description ? "input-pri-error h-36" : "input-pri h-36",
                            root: "mb-6"
                        },
                        id: "description",
                        type: "text",
                        onChange: formik.handleChange,
                        onBlur: formik.handleBlur,
                        value: formik.values.description,
                        error: formik.errors.description && formik.touched.description ? "Description is required" : "",
                        required: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageUploader/* default */.Z, {
                        formik: formik
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                        classNames: {
                            label: "label-form",
                            input: formik.errors.website_url && formik.touched.website_url ? "input-pri-error" : "input-pri",
                            root: "mb-6"
                        },
                        label: "Website",
                        id: "website_url",
                        type: "link",
                        onChange: formik.handleChange,
                        onBlur: formik.handleBlur,
                        value: formik.values.website_url,
                        error: formik.errors.website_url && formik.touched.website_url ? formik.errors.website_url : "",
                        required: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: "label-form",
                                children: "Discord"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                classNames: {
                                    label: "label-form",
                                    input: formik.errors.discord_url && formik.touched.discord_url ? "input-pri-error" : "input-pri",
                                    root: "mb-6"
                                },
                                id: "discord_url",
                                type: "link",
                                onBlur: formik.handleBlur,
                                onChange: formik.handleChange,
                                value: formik.values.discord_url,
                                error: formik.errors.discord_url && formik.touched.discord_url ? formik.errors.discord_url : ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: "label-form",
                                children: "Twitter"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                classNames: {
                                    label: "label-form",
                                    input: formik.errors.twitter_url && formik.touched.twitter_url ? "input-pri-error" : "input-pri",
                                    root: "mb-6"
                                },
                                id: "twitter_url",
                                type: "link",
                                onChange: formik.handleChange,
                                onBlur: formik.handleBlur,
                                value: formik.values.twitter_url,
                                error: formik.errors.twitter_url && formik.touched.twitter_url ? formik.errors.twitter_url : ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: "label-form",
                                children: "Opensea"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                classNames: {
                                    label: "label-form",
                                    input: formik.errors.opensea_url && formik.touched.opensea_url ? "input-pri-error" : "input-pri",
                                    root: "mb-6"
                                },
                                id: "opensea_url",
                                type: "link",
                                onBlur: formik.handleBlur,
                                onChange: formik.handleChange,
                                value: formik.values.opensea_url,
                                error: formik.errors.opensea_url && formik.touched.opensea_url ? formik.errors.opensea_url : ""
                            })
                        ]
                    }),
                    chainId !== (expectedChain === null || expectedChain === void 0 ? void 0 : expectedChain.chainId) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                        className: "btn-pri mt-10 mb-10 px-12",
                        onClick: switchNet,
                        children: [
                            "Switch to ",
                            expectedChain === null || expectedChain === void 0 ? void 0 : expectedChain.chainName,
                            " Network"
                        ]
                    }) : // () => setVisible((v) => !v)
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        className: "btn-pri mt-10 mb-10 px-12",
                        type: "submit",
                        onClick: initOverLay,
                        children: "Save"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LoadingModal, {
                loadingOpen: loadingModalOpened,
                setLoadingOpen: setLoadingModalOpened,
                setLoadingPrompt: setLoadingPrompt,
                loadingPrompt: loadingPrompt,
                setOpened: setOpened
            })
        ]
    });
};
/* harmony default export */ var components_EditCampaignModal = (EditCampaignModal);

;// CONCATENATED MODULE: ./src/airdrop/hooks/useFetchEligible.ts




var useFetchEligible = function(expectedChainId, campaign_address, wallet_address, claimInfoHash) {
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)(), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(), data = ref2[0], setData = ref2[1];
    (0,react.useEffect)(function() {
        var getWalletEligible = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var res, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            setLoading(true);
                            setError(null);
                            return [
                                4,
                                (0,project/* getWalletClaimInfo */.dL)({
                                    chain_id: String(expectedChainId),
                                    campaign_address: campaign_address,
                                    wallet_address: wallet_address,
                                    claimInfoHash: claimInfoHash
                                })
                            ];
                        case 1:
                            res = _state.sent();
                            setData(res);
                            setLoading(false);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            console.log("error", e);
                            setError(e);
                            setLoading(false);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getWalletEligible() {
                return _ref.apply(this, arguments);
            };
        }();
        if (campaign_address !== undefined && claimInfoHash !== undefined && wallet_address !== undefined) {
            getWalletEligible();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        campaign_address,
        wallet_address,
        claimInfoHash
    ]);
    return {
        loading: loading,
        error: error,
        data: data
    };
};
/* harmony default export */ var hooks_useFetchEligible = (useFetchEligible);

// EXTERNAL MODULE: ./src/airdrop/components/ImageProcessor.js
var ImageProcessor = __webpack_require__(97404);
// EXTERNAL MODULE: ./src/airdrop/components/account/EmailAuthModal.tsx + 2 modules
var EmailAuthModal = __webpack_require__(28577);
// EXTERNAL MODULE: ./src/airdrop/hooks/useAccountAnonymousInfo.ts + 1 modules
var useAccountAnonymousInfo = __webpack_require__(73148);
// EXTERNAL MODULE: ./src/stores/index.ts + 23 modules
var stores = __webpack_require__(27234);
// EXTERNAL MODULE: ./src/components/common/PageHead.tsx
var PageHead = __webpack_require__(47270);
// EXTERNAL MODULE: ./src/airdrop/utils/urlToHttp.ts
var urlToHttp = __webpack_require__(49556);
// EXTERNAL MODULE: ./src/config/config.js
var config = __webpack_require__(35055);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(6767);
// EXTERNAL MODULE: ./node_modules/@sentry/nextjs/esm/index.client.js + 70 modules
var index_client = __webpack_require__(11772);
;// CONCATENATED MODULE: ./src/airdrop/components/CampaignDetail.tsx











// import { getWalletClaimInfo } from '../models/project';



// import OwnerActions from '../components/OwnerActions';

// import PageNotFound from './PageNotFound';



// import urlToHttp from '../utils/urlToHttp';





// import { useFormik } from 'formik';













var stopIcon = "/airdrop_assets/stop.png";
var editIcon = "/airdrop_assets/edit.png";
var twitterIcon = "/airdrop_assets/twitter.png";
var discordIcon = "/airdrop_assets/discord.png";
var etherscanIcon = "/airdrop_assets/etherscan.png";
var linkIcon = "/airdrop_assets/link.png";
var coinIcon = "/airdrop_assets/coin.png";
var nftIcon = "/airdrop_assets/nft.png";
var leftArrow = "/airdrop_assets/arrow-left-solid.svg";
var CamapignDetail = function(param) {
    var campaignType = param.campaignType, setErrorMessage = param.setErrorMessage;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var router = (0,next_router.useRouter)();
    var _query = router.query, chainName = _query.chainName, address = _query.address;
    var ref9 = (0,react.useState)(false), claimModalOpened = ref9[0], setClaimModalOpened = ref9[1];
    var ref10 = (0,react.useState)(false), editModalOpened = ref10[0], setEditModalOpened = ref10[1];
    var ref11 = (0,react.useState)(false), stopModalOpened = ref11[0], setStopModalOpened = ref11[1];
    var ref12 = (0,react.useState)(false), emailAuthOpened = ref12[0], setEmailAuthOpened = ref12[1];
    var ref13 = (0,react.useState)("claiming"), claimStatus = ref13[0], setClaimStatus = ref13[1];
    var expectedChain = KaratDaoSupportedChain/* KARATDAO_DEFAULT_SUPPORTED_CHAINS.find */.f.find(function(network) {
        return network.chainName.toLowerCase() === (chainName === null || chainName === void 0 ? void 0 : chainName.toLowerCase());
    }); //getExplorerAddressLink
    var expectedChainId = expectedChain === null || expectedChain === void 0 ? void 0 : expectedChain.chainId;
    var chainNameEth = chainName === "Mainnet" ? "Ethereum" : chainName;
    var chain = (0,dist/* useNetwork */.LN)().chain;
    var ref14 = (0,useAccount/* default */.Z)(), account = ref14.address;
    var switchNetworkAsync = (0,dist/* useSwitchNetwork */.g0)().switchNetworkAsync;
    var notifications = useNotifications().notifications;
    var campaignAddr = address ? address_lib_esm.isAddress(address) ? address : undefined : undefined;
    var campaignAddrArray = address ? [
        address
    ] : undefined;
    var ref15 = (0,react.useState)(false), showStopPrompt = ref15[0], setShowStopPrompt = ref15[1];
    // const { campaignInfo, loading: campaignLoading } = useCampaignInfo(
    //   campaignType?.toUpperCase(),
    //   campaignAddrArray,
    //   expectedChainId
    // );
    var campaignInfo = (0,useCampaignInfo/* default */.Z)(//loading: campaignLoading FIXME 0608
    campaignType === null || campaignType === void 0 ? void 0 : campaignType.toUpperCase(), campaignAddrArray, expectedChainId).campaignInfo;
    console.log("campaignInfo", campaignInfo);
    var campaign = campaignInfo[0];
    var ref16 = (0,useFetchData/* default */.Z)(campaign === null || campaign === void 0 ? void 0 : campaign.baseInfoURI), baseInfoURILoading = ref16.loading, // error: baseInfoURIError,
    baseInfoURIData = ref16.data;
    var info = {
        description: "",
        twitter_url: "",
        discord_url: "",
        website_url: "",
        opensea_url: "",
        thumbnail: ""
    };
    var campaign_address = address;
    // const wallet_address = account;
    // console.log(campaign);
    var ref17 = (0,useFetchData/* default */.Z)(campaign === null || campaign === void 0 ? void 0 : campaign.frozenInfoURI), frozenInfoURILoading = ref17.loading, // eslint-disable-next-line
    frozenInfoURIError = ref17.error, frozenInfoURIData = ref17.data;
    var claimInfoURL = // There's a bug with the claim info for this campaign
    // claimInfo could be undefined..
    address === "0xb403805916ccd23624a706e9fd37c713bb38078a" && chainName === "Polygon" ? "ipfs://QmWQyzLhntqAc6Kfn2JWgqDXq4oXqwuGi44yR9oUCPkNi3" : frozenInfoURIData === null || frozenInfoURIData === void 0 ? void 0 : frozenInfoURIData.claimInfo;
    // turn all upper case to lower case
    var wallet_address = account;
    var wallet_address_lower = wallet_address === null || wallet_address === void 0 ? void 0 : wallet_address.toLowerCase();
    var ref18 = hooks_useFetchEligible(expectedChainId, campaign_address, wallet_address_lower, claimInfoURL), claimedLoading = ref18.loading, claimedError = ref18.error, claimedEligible = ref18.data;
    var isActive = campaign === null || campaign === void 0 ? void 0 : campaign.isActive;
    var isGone =  true ? (campaign === null || campaign === void 0 ? void 0 : (ref = campaign.reach) === null || ref === void 0 ? void 0 : ref.toNumber()) === (campaign === null || campaign === void 0 ? void 0 : (ref1 = campaign.claimedNum) === null || ref1 === void 0 ? void 0 : ref1.toNumber()) : 0;
    var proof = account ? claimedEligible === null || claimedEligible === void 0 ? void 0 : claimedEligible.proof : null;
    var amount = account ? claimedEligible === null || claimedEligible === void 0 ? void 0 : claimedEligible.amount : null;
    var claimed = hooks_useClaimed(campaignAddr, account, expectedChainId).claimed;
    //check if the user is claimed or not
    var isClaimed = proof && claimed;
    // check if a user is eligible to claim
    var isEligible = proof != null && claimedError == null; //proof === [];
    // const campaign_address = "0x60aA3BBe0f411d7E677c29210f156F1BfC0Ac99e";
    // const wallet_address = "0x37422a43cf57Ea71B6aF354Ee7BA5a77c56C9E20";
    var ref19 = useClaimAirdrop(campaignType, campaignAddr), claimAirdrop = ref19.claimAirdrop, claimAirdropState = ref19.claimAirdropState;
    (0,react.useEffect)(function() {
        if (notifications.filter(function(notification) {
            return notification.type === "transactionSucceed" && notification.transactionName === "Claim Airdrop";
        }).length > 0) {
            setClaimStatus("finished");
        }
    }, [
        notifications
    ]);
    (0,react.useEffect)(function() {
        if (claimAirdropState.status === "Exception") {
            setClaimModalOpened(false);
            setErrorMessage(new Error(claimAirdropState.errorMessage));
            mixpanel_cjs_default().track("claim_airdrop_error", claimAirdropState);
            index_client/* captureException */.Tb(new Error(claimAirdropState.errorMessage));
        }
    }, [
        claimAirdropState,
        setErrorMessage
    ]);
    var isOwner = account && account === (campaign === null || campaign === void 0 ? void 0 : campaign.owner);
    var isCSV = (frozenInfoURIData === null || frozenInfoURIData === void 0 ? void 0 : frozenInfoURIData.requirements) === "CSV" || (frozenInfoURIData === null || frozenInfoURIData === void 0 ? void 0 : frozenInfoURIData.csv) === true;
    var csvName = isCSV ? campaign.name.includes("Elysium") ? "Elysium Special Guest List RSVP" : campaign.name.includes("NO HESI KEY") ? "Holder of NHCC" : campaign.name.includes("LiveArt: Meta-Morphic x Machina") ? "KaratDAO Community with 1+ ETH" : (frozenInfoURIData === null || frozenInfoURIData === void 0 ? void 0 : frozenInfoURIData.csvName) || "Private" : null;
    var HESI_TEXT = "No Hesi is an Exclusive Elite Group. Being a Holder of this this key signifies that you are an OG and diamond hands holder. You officially have the keys to our Metaverse Island and game.";
    var description = (campaign === null || campaign === void 0 ? void 0 : campaign.name.includes("NO HESI KEY")) ? HESI_TEXT : baseInfoURIData === null || baseInfoURIData === void 0 ? void 0 : baseInfoURIData.description;
    // const promotionalText = 'Passholders will receive exclusive airdrops in the future including: $BNB, $ANKR, $KCS, $GMT, and $KARAT.';
    var discord_url = (campaign === null || campaign === void 0 ? void 0 : campaign.name.includes("Tiger VC DAO & Consensus")) ? "https://discord.gg/Ng69Qehq6e" : baseInfoURIData === null || baseInfoURIData === void 0 ? void 0 : baseInfoURIData.discord_url;
    var website_url = (campaign === null || campaign === void 0 ? void 0 : campaign.name.includes("Tiger VC DAO & Consensus")) ? "https://tigervcdao.com/" : baseInfoURIData === null || baseInfoURIData === void 0 ? void 0 : baseInfoURIData.website_url;
    var dynamic_fit = (campaign === null || campaign === void 0 ? void 0 : campaign.name.includes("StepG&Karat")) ? "object-contain" : "object-cover";
    var disabled = isClaimed || baseInfoURILoading || frozenInfoURILoading || !isEligible || !isActive || isGone;
    var loading = // campaignLoading || //FIXME 0608 When you switch from another chain to the campaign chain, it will forever load. Temp workaround so far
    baseInfoURILoading || frozenInfoURILoading;
    var chainIcon = (0,format/* getChainIcon */.Sv)(chainNameEth);
    var accountInfo = (0,useAccountAnonymousInfo/* default */.Z)().accountInfo;
    var verified = !!(accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.is_email_verified);
    var action = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!chain || !expectedChainId || !switchNetworkAsync) {
                        return [
                            2
                        ];
                    }
                    if (!(chain.id !== expectedChainId)) return [
                        3,
                        1
                    ];
                    switchNetworkAsync(expectedChainId);
                    return [
                        3,
                        4
                    ];
                case 1:
                    if (!(isEligible && !isClaimed)) return [
                        3,
                        4
                    ];
                    ga/* event */.B("claim", {
                        event_category: "button"
                    });
                    if (!verified) return [
                        3,
                        3
                    ];
                    setClaimStatus("claiming");
                    setClaimModalOpened(true);
                    return [
                        4,
                        claimAirdrop(amount, proof)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    setEmailAuthOpened(true);
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        verified,
        claimAirdrop,
        chain,
        switchNetworkAsync,
        expectedChainId,
        amount, 
    ]);
    var changeEmailAuth = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(isOpen) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setEmailAuthOpened(isOpen);
                        if (!!isOpen) return [
                            3,
                            2
                        ];
                        setClaimStatus("claiming");
                        setClaimModalOpened(true);
                        return [
                            4,
                            claimAirdrop(amount, proof)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function changeEmailAuth(isOpen) {
            return _ref.apply(this, arguments);
        };
    }();
    var loadingText = function() {
        // if (isOwner) return 'View Transactions';
        if (claimedLoading) return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-row items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mr-1",
                    children: "Loading"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                    color: "#292939",
                    size: 14
                })
            ]
        });
        if (isClaimed) return "Claimed";
        // if (claimException) return 'Claim Failed';
        if (isActive === false) return "Campaign has been stopped";
        if (isGone) {
            return "Nothing Left";
        }
        if (isEligible) {
            if ((chain === null || chain === void 0 ? void 0 : chain.id) !== expectedChainId) {
                return "Switch to ".concat(expectedChain === null || expectedChain === void 0 ? void 0 : expectedChain.chainName, " to claim");
            }
            return "Claim";
        }
        if (!isEligible) return "You are not eligible";
    };
    var secondaryText = function() {
        // if (isOwner) return '';
        // if (claimException) return claimAirdropState.errorMessage!;
        if (isEligible && frozenInfoURIData) {
            if (campaignType === "NFT") {
                return "Eligible for ".concat(Number(amount), " ").concat(campaignType);
            } else {
                var formattedAmount = parseFloat((0,units_lib_esm.formatUnits)(amount, frozenInfoURIData.airdropToken.decimals));
                return "Eligible for ".concat(formattedAmount, " ").concat(frozenInfoURIData.airdropToken.symbol);
            }
        }
        return "";
    };
    if ((campaign === null || campaign === void 0 ? void 0 : campaign.address) === "0xcaaac618b5dec930c4c7c00d011a91196b112427" && (campaign === null || campaign === void 0 ? void 0 : campaign.name) === "Hay twitter airdrop campaign for eligible winners") {
        campaign.name = "HAY twitter airdrop campaign for eligible winners";
    }
    var displayTotal = !((campaign === null || campaign === void 0 ? void 0 : campaign.name) === "HAY airdrop for early borrowers" && (campaign === null || campaign === void 0 ? void 0 : campaign.address) === "0x8c33532386aead57d0643d6a66c57ae77d5df2de" || (campaign === null || campaign === void 0 ? void 0 : campaign.name) === "HAY twitter airdrop campaign for eligible winners" && (campaign === null || campaign === void 0 ? void 0 : campaign.address) === "0xcaaac618b5dec930c4c7c00d011a91196b112427");
    // campaign.name != 'HAY airdrop for early borrowers';
    (0,react.useEffect)(function() {}, [
        baseInfoURIData
    ]);
    var editModalInit = function() {
        setEditModalOpened(true);
    };
    var stopModalInit = function() {
        setShowStopPrompt(true);
        setStopModalOpened(true);
    };
    var communityList = (0,stores/* useTypedSelector */.ix)(function(state) {
        return state.community.list;
    });
    var tdk;
    if (campaign === null || campaign === void 0 ? void 0 : campaign.name) {
        tdk = {
            title: campaign.name,
            description: description,
            keywords: "KaratDAO,".concat(chainNameEth, ",").concat(campaignType),
            cover: (0,urlToHttp/* default */.Z)(baseInfoURIData === null || baseInfoURIData === void 0 ? void 0 : baseInfoURIData.image)[0]
        };
    }
    if (!address) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHead/* default */.Z, {
            tdk: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, config/* TDK */._T), {
                title: "KaratDAO ".concat(campaignType === "NFT" ? "NFT" : "Token", " Campaign"),
                description: "Claim your airdrop today on KaratDAO"
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHead/* default */.Z, {
                tdk: tdk
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-full flex items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                    color: "#ADB5FF"
                })
            }) : !campaign ? // <PageNotFound name="Campaign" />
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}) //FIXME 0608 When it's loading,  we don't show the page not found
             : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-wrap sm:grid sm:grid-cols-2 sm:space-x-4 max-w-5xl mx-auto p-5 md:p-14",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-start justify-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative flex flex-col ",
                                children: [
                                     true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute w-full p-4 font-semibold",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-row items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex items-center rounded-sm bg-[#191926] text-bodyS text-white px-2 py-1 ",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            className: "mr-1 h-4 ",
                                                            src: chainIcon,
                                                            alt: "chain_icon"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            children: chainNameEth
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-row items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            className: "mr-1 h-8 rounded-full",
                                                            src: campaignType === "NFT" ? nftIcon : coinIcon,
                                                            alt: "type_icon"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "rounded-sm text-bodyS text-white bg-[#191926] px-2 py-1",
                                                            children: campaignType === "NFT" ? "NFT" : frozenInfoURIData === null || frozenInfoURIData === void 0 ? void 0 : (ref2 = frozenInfoURIData.airdropToken) === null || ref2 === void 0 ? void 0 : ref2.name
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }) : 0,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageProcessor/* default */.Z, {
                                        src: baseInfoURIData === null || baseInfoURIData === void 0 ? void 0 : baseInfoURIData.image,
                                        size: "s600",
                                        "data-testid": "campaign-image",
                                        className: "".concat(dynamic_fit, " h-96 w-96 rounded-md")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-2 flex",
                                children: isOwner ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex space-x-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: "btn-bgv2 text-white flex items-center justify-center px-6",
                                            onClick: editModalInit,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "mr-2 h-4",
                                                    src: editIcon,
                                                    alt: "edit"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: "Edit"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            className: "btn-bgv2 text-white flex items-center justify-center px-6",
                                            onClick: stopModalInit,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "mr-2 h-4",
                                                    src: stopIcon,
                                                    alt: "stop"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: "Stop"
                                                })
                                            ]
                                        })
                                    ]
                                }) : null
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-3 text-lg font-bold",
                                "data-testid": "campaign-name",
                                children: campaign.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-3 flex",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-gray1",
                                        children: "Created By \xa0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: expectedChain === null || expectedChain === void 0 ? void 0 : expectedChain.getExplorerAddressLink(campaign.owner),
                                        target: "_blank",
                                        rel: "noreferrer",
                                        className: "text-primary",
                                        children: (0,helper/* trimAddr */.nM)(campaign.owner)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "mb-6 flex items-center space-x-7",
                                    children: [
                                        (baseInfoURIData === null || baseInfoURIData === void 0 ? void 0 : baseInfoURIData.twitter_url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: baseInfoURIData === null || baseInfoURIData === void 0 ? void 0 : baseInfoURIData.twitter_url,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "h-4",
                                                src: twitterIcon,
                                                alt: "twitter"
                                            })
                                        }),
                                        discord_url && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: discord_url,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "h-4",
                                                src: discordIcon,
                                                alt: "discordIcon"
                                            })
                                        }),
                                        website_url && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: website_url,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "h-5",
                                                src: linkIcon,
                                                alt: "linkIcon"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: expectedChain === null || expectedChain === void 0 ? void 0 : expectedChain.getExplorerAddressLink(address),
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                className: "h-4",
                                                src: etherscanIcon,
                                                alt: "etherscanIcon"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: " text-gray",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "whitespace-pre-line break-words",
                                    "data-testid": "campaign-desc",
                                    children: description
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-8 mb-6 border border-bgv"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-3 ",
                                children: "Requirements to Qualify"
                            }),
                            (frozenInfoURIData === null || frozenInfoURIData === void 0 ? void 0 : frozenInfoURIData.version) && frozenInfoURIData.version >= 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-10 flex flex-wrap",
                                children: (ref5 = frozenInfoURIData === null || frozenInfoURIData === void 0 ? void 0 : (ref3 = frozenInfoURIData.requirements) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.requirement) === null || ref5 === void 0 ? void 0 : ref5.map(function(item, index) {
                                    if (item.type === "community") {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mb-2 mr-2 rounded-md border border-gray_e7 px-3 py-3 ",
                                            children: [
                                                item.community.name,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-xs text-gray1",
                                                    children: "Community"
                                                })
                                            ]
                                        }, "community-".concat(index));
                                    } else if (item.type === "whitelist") {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mb-2 mr-2 rounded-md border border-gray_e7 px-3 py-3",
                                            children: [
                                                item.name,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-xs text-gray1",
                                                    children: "AllowList"
                                                })
                                            ]
                                        }, "whitelist-".concat(index));
                                    } else {
                                        var ref;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "mb-2 mr-2 rounded-md border border-gray_e7 px-3 py-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: (ref = item.token) === null || ref === void 0 ? void 0 : ref.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "text-xs text-gray1",
                                                    children: [
                                                        "Min. ",
                                                        item.requiredAmount
                                                    ]
                                                })
                                            ]
                                        }, "token-".concat(index));
                                    }
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-10 flex",
                                children: isCSV ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mr-2 rounded-md border border-gray_e7 px-3 py-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: csvName
                                    })
                                }) : frozenInfoURIData === null || frozenInfoURIData === void 0 ? void 0 : (ref6 = frozenInfoURIData.requirements) === null || ref6 === void 0 ? void 0 : ref6.map(function(items) {
                                    var ref;
                                    return (ref = items.requirement) === null || ref === void 0 ? void 0 : ref.map(function(req, index) {
                                        var ref;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                            className: "mr-2 rounded-md border border-gray_e7 px-3 py-3",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: (ref = req.requiredToken) === null || ref === void 0 ? void 0 : ref.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "text-xs text-gray1",
                                                    children: [
                                                        "Min. ",
                                                        req.requiredAmount
                                                    ]
                                                })
                                            ]
                                        }, index);
                                    });
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-8 mb-6 border border-bgv"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-4",
                                children: "Airdrop Details"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid grid-cols-2 ",
                                children: [
                                    displayTotal && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-1 text-gray1",
                                                children: "Total Supply"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-5 ",
                                                children: campaign.reach.toString()
                                            })
                                        ]
                                    }),
                                    campaign.claimedNum > 10 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-1 text-gray1",
                                                children: "Airdrop Claimed"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-5 ",
                                                children: campaign.claimedNum.toString()
                                            })
                                        ]
                                    }) : null,
                                    campaignType === "TOKEN" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-1 text-gray1",
                                                children: "Token Address"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                rel: "noreferrer",
                                                href: expectedChain === null || expectedChain === void 0 ? void 0 : expectedChain.getExplorerAddressLink(frozenInfoURIData === null || frozenInfoURIData === void 0 ? void 0 : (ref7 = frozenInfoURIData.airdropToken) === null || ref7 === void 0 ? void 0 : ref7.address),
                                                className: "font-bold text-primary",
                                                children: (0,helper/* trimAddr */.nM)(frozenInfoURIData === null || frozenInfoURIData === void 0 ? void 0 : (ref8 = frozenInfoURIData.airdropToken) === null || ref8 === void 0 ? void 0 : ref8.address, 5)
                                            })
                                        ]
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-5 flex w-full flex-col items-start justify-center sm:mt-10",
                                children: !account ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex w-full flex-col items-center justify-center sm:w-auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Web3ModalButton/* Web3ModalButton */.u, {
                                        className: "w-full sm:w-auto"
                                    })
                                }) : // claim button
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex w-full flex-col items-center justify-center sm:w-auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: "btn-pri flex w-full flex-row justify-center px-12 sm:w-auto  ".concat(disabled && "bg-gray2 hover:bg-gray2"),
                                            disabled: disabled,
                                            onClick: action,
                                            "data-testid": "claim-btn",
                                            children: loadingText()
                                        }),
                                        secondaryText() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-2 text-xs text-gray1",
                                            children: secondaryText()
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ClaimModal, {
                opened: claimModalOpened,
                // opened={true}
                setOpened: setClaimModalOpened,
                claimStatus: claimStatus
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_EditCampaignModal, {
                opened: editModalOpened,
                setOpened: setEditModalOpened,
                baseInfo: baseInfoURIData ? baseInfoURIData : info,
                campaignAddrArray: campaignAddrArray,
                campaignType: campaignType,
                expectedChain: expectedChain
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_StopCampaignModal, {
                campaign: campaign,
                opened: stopModalOpened,
                setOpened: setStopModalOpened,
                campaignAddrArray: campaignAddrArray,
                campaignType: campaignType,
                expectedChain: expectedChain,
                showStopPrompt: showStopPrompt,
                setShowStopPrompt: setShowStopPrompt
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailAuthModal/* default */.Z, {
                opened: emailAuthOpened,
                setOpened: changeEmailAuth
            })
        ]
    });
};
/* harmony default export */ var CampaignDetail = (CamapignDetail);


/***/ }),

/***/ 54167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_common_Nav__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27356);
/* harmony import */ var react_div_100vh__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66409);







var Container = function(_param) {
    var children = _param.children, id = _param.id, showConnect = _param.showConnect, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "id",
        "showConnect"
    ]);
    var height = (0,react_div_100vh__WEBPACK_IMPORTED_MODULE_3__/* .use100vh */ .g)();
    var connectShow = typeof showConnect === "undefined" ? true : showConnect;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        className: "layout-content",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Nav__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                showConnect: connectShow
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    height: height ? "".concat(height - 60, "px") : "calc(100vh-60px)"
                },
                id: id,
                className: "overflow-y-scroll overflow-x-hidden",
                children: children
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Container);


/***/ }),

/***/ 60105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_dropzone__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32512);
/* harmony import */ var _utils_urlToHttp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49556);




// import { useEffect } from 'react';

var ImageUploader = function(props) {
    var formik = props.formik;
    var ref = (0,react_dropzone__WEBPACK_IMPORTED_MODULE_1__/* .useDropzone */ .uI)({
        noDrag: true,
        accept: {
            "image/*": [
                ".png",
                ".gif",
                ".jpeg",
                ".jpg",
                ".webp"
            ]
        },
        maxSize: 35 * 1024 * 1024,
        maxFiles: 1,
        onDrop: function(acceptedFiles) {
            // setFiles(
            //   // eslint-disable-next-line
            //   acceptedFiles.map((file) => {
            //     return Object.assign(file, {
            //       preview: URL.createObjectURL(file),
            //     });
            //   })
            // );
            if (acceptedFiles[0] !== undefined) {
                formik.setFieldValue("thumbnail", Object.assign(acceptedFiles[0], {
                    preview: URL.createObjectURL(acceptedFiles[0])
                }));
            }
        }
    }), getRootProps = ref.getRootProps, getInputProps = ref.getInputProps;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: "label-form",
                htmlFor: "grid-Thumbnail",
                children: [
                    "Image",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "ml-1 text-warning",
                        children: "*"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, getRootProps({
                className: "dropzone"
            })), {
                id: "createpage-image-dropzone",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, getInputProps()), {
                        id: "createpage-image-input"
                    })),
                    formik.values.thumbnail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        id: "createpage-image-preview",
                        "aria-label": "createpage-image-preview",
                        className: "mb-6 h-40",
                        src: formik.values.thumbnail.preview ? formik.values.thumbnail.preview : (0,_utils_urlToHttp__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(formik.values.thumbnail)[0],
                        alt: "upload"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pointer-events-auto mb-6 flex h-40 w-60 flex-col items-center justify-center border border-gray_e4",
                        id: "createpage-image-undefined",
                        "aria-label": "createpage-image-undefined",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: " border-primary text-primary border rounded-full w-[30px] h-[30px] flex items-center justify-center text-3xl leading-none",
                            "text-primary": true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "-mt-1",
                                children: "+"
                            })
                        })
                    })
                ]
            })),
            formik.errors.thumbnail && formik.touched.thumbnail ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-red-500",
                id: "createpage-image-errormsg",
                "aria-label": "createpage-image-errormsg",
                children: formik.errors.thumbnail
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageUploader);


/***/ }),

/***/ 3558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* binding */ n; }
});

// UNUSED EXPORTS: createStore

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-hooks-global-state/node_modules/zustand/esm/vanilla.js
const createStoreImpl = (createState) => {
  let state;
  const listeners = /* @__PURE__ */ new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (nextState !== state) {
      const previousState = state;
      state = replace ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => listeners.clear();
  const api = { setState, getState, subscribe, destroy };
  state = createState(
    setState,
    getState,
    api
  );
  return api;
};
const createStore = (createState) => createState ? createStoreImpl(createState) : createStoreImpl;



// EXTERNAL MODULE: ./node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(52798);
;// CONCATENATED MODULE: ./node_modules/react-hooks-global-state/node_modules/zustand/esm/index.js






const { useSyncExternalStoreWithSelector } = with_selector;
function useStore(api, selector = api.getState, equalityFn) {
  const slice = useSyncExternalStoreWithSelector(
    api.subscribe,
    api.getState,
    api.getServerState || api.getState,
    selector,
    equalityFn
  );
  (0,react.useDebugValue)(slice);
  return slice;
}
const createImpl = (createState) => {
  const api = typeof createState === "function" ? createStore(createState) : createState;
  const useBoundStore = (selector, equalityFn) => useStore(api, selector, equalityFn);
  Object.assign(useBoundStore, api);
  return useBoundStore;
};
const create = (createState) => createState ? createImpl(createState) : createImpl;
var create$1 = create;



;// CONCATENATED MODULE: ./node_modules/react-hooks-global-state/dist/index.modern.js
const o=(t,e)=>{if(!t.includes(e))throw new Error(`'${e}' not found. It must be provided in initialState as a property key.`)},n=r=>{const n=create$1(()=>r),s=Object.keys(r),a=(t,e)=>{ false&&0,n.setState(r=>{return{[t]:(o=r[t],n=e,"function"==typeof n?n(o):n)};var o,n})};return{useGlobalState:e=>{ false&&0;const r=(0,react.useCallback)(t=>t[e],[e]);return[n(r),(0,react.useCallback)(t=>a(e,t),[e])]},getGlobalState:t=>( false&&0,n.getState()[t]),setGlobalState:a,subscribe:(t,e)=>{n.subscribe((r,o)=>{r[t]!==o[t]&&e(r[t])})}}},s=(o,n=o(void 0,{type:void 0}),a)=>{if(a)return a(s)(o,n);const i=e(r(o,n)),u=Object.keys(n),c=e=>{ false&&0;const r=t(t=>t[e],[e]);return i(r)};return{useStoreState:c,useGlobalState:e=>( false&&0,[c(e),t(t=>{i.setState(r=>{return{[e]:(o=r[e],n=t,"function"==typeof n?n(o):n)};var o,n})},[e])]),getState:i.getState,dispatch:i.dispatch}};
//# sourceMappingURL=index.modern.js.map


/***/ })

}]);